/**
 * PERFUM by Aleja — Custom AJAX Load More & Infinite Scroll
 * Handles loading more products in the collection grid dynamically.
 */

(function () {
  function initInfiniteScroll() {
    const container = document.querySelector('.perfum-load-more-container[data-pagination-type="infinite_scroll"]');
    const button = document.getElementById('PerfumLoadMore');
    
    if (!container || !button) return;
    
    // Disconnect previous observer if exists
    if (window.perfumInfiniteObserver) {
      window.perfumInfiniteObserver.disconnect();
    }
    
    window.perfumInfiniteObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !button.classList.contains('loading')) {
          button.click();
        }
      });
    }, {
      rootMargin: '250px' // Load 250px before reaching the bottom
    });
    
    window.perfumInfiniteObserver.observe(button);
  }

  function loadNextPage(button) {
    if (button.classList.contains('loading')) return;
    button.classList.add('loading');
    
    const textSpan = button.querySelector('.load-more-text');
    const spinnerSpan = button.querySelector('.loading-spinner');
    
    if (textSpan) textSpan.classList.add('hidden');
    if (spinnerSpan) spinnerSpan.classList.remove('hidden');
    
    const url = button.getAttribute('href');
    
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        
        // Find and append new grid items
        const newGridItems = parsedHTML.querySelectorAll('#product-grid > li');
        const grid = document.getElementById('product-grid');
        
        if (grid && newGridItems.length > 0) {
          newGridItems.forEach(item => {
            grid.appendChild(item);
          });
        }
        
        // Find new pagination container
        const newContainer = parsedHTML.querySelector('.perfum-load-more-container');
        const currentContainer = document.querySelector('.perfum-load-more-container');
        
        if (currentContainer) {
          if (newContainer) {
            currentContainer.outerHTML = newContainer.outerHTML;
            // Re-initialize infinite scroll if the new container also has infinite scroll type
            initInfiniteScroll();
          } else {
            currentContainer.remove();
          }
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
      })
      .finally(() => {
        button.classList.remove('loading');
        if (textSpan) textSpan.classList.remove('hidden');
        if (spinnerSpan) spinnerSpan.classList.add('hidden');
      });
  }

  // Use event delegation for the load more button click
  document.body.addEventListener('click', function (e) {
    const loadMoreBtn = e.target.closest('#PerfumLoadMore');
    if (loadMoreBtn) {
      e.preventDefault();
      loadNextPage(loadMoreBtn);
    }
  });

  // Setup MutationObserver to watch #ProductGridContainer for facets changes
  document.addEventListener('DOMContentLoaded', () => {
    initInfiniteScroll();
    
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const observer = new MutationObserver(() => {
        initInfiniteScroll();
      });
      observer.observe(gridContainer, { childList: true });
    }
  });
})();
